<template>
    <div class="business-content-main">
        <div class="bread-nav">
            <breadcrumb></breadcrumb>
        </div>
        <el-container style="height: 650px">
            <el-header style="line-height: 60px">
                <el-row type="flex" :gutter="20" align="middle">
                    <el-col :span="24">
                        <el-input clearable size="small" style="width: 200px; margin-right: 10px" v-model="searchData.name" placeholder="时段名"></el-input>
                        <el-button size="small" class="btn-primary" @click="getWorkTimeIntervalsList">查询</el-button>
                        <el-button size="small" class="btn-primary" v-if="permission.add" @click="showEditWorkTimeInterval()">{{ permission.add }}</el-button>
                        <el-button size="small" class="btn-primary" v-if="permission.del" @click="delWorkTimeInterval">{{ permission.del }}</el-button>
                    </el-col>
                </el-row>
            </el-header>
            <el-container style="height: 100%">
                <el-main width="100%" height="100%" style="padding-top: 0px">
                    <el-table @selection-change="handleSelectionChange" :header-cell-style="{ background: '#F2F6FC' }" :data="workTimeIntervalsList" border style="width: 100%">
                        <el-table-column type="selection" width="55"></el-table-column>
                        <el-table-column min-width="300px" prop="Name" label="时段名称"></el-table-column>
                        <el-table-column min-width="300px" prop="OnDutyTime" label="上班时间"></el-table-column>
                        <el-table-column min-width="300px" prop="OffDutyTime" label="下班时间"></el-table-column>
                        <el-table-column label="操作">
                            <template slot-scope="scope">
                                <div class="ops-ctn">
                                    <el-button type="text" size="mini" v-if="permission.edit" @click="showEditWorkTimeInterval(scope)">{{ permission.edit }}</el-button>
                                    <el-button type="text" size="mini" v-if="permission.del" @click="delWorkTimeInterval(scope)">{{ permission.del }}</el-button>
                                </div>
                            </template>
                        </el-table-column>
                    </el-table>
                </el-main>
                <div class="pagination-ctn">
                    <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="searchData.page"
                        :page-sizes="[commonPageSize, 20, 30, 40, 50]"
                        :page-size="searchData.limit"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="workTimeIntervalsList.length"
                    ></el-pagination>
                </div>
            </el-container>
            <el-dialog title="时段" :visible.sync="dialogVisible" width="480px">
                <el-form label-width="90px" :rules="rules" :model="workTimeInterval" ref="workTimeInterval" style="margin-top: 20px">
                    <el-form-item label="时段名称:" prop="name">
                        <el-input v-model="workTimeInterval.name" placeholder="请填写时段名称"></el-input>
                    </el-form-item>
                    <el-form-item label="上下班时间:">
                        <!-- <el-time-picker
              format="HH:mm"
              is-range
              clearable
              editable
              v-model="workTimeInterval.dateTime"
              range-separator="至"
              start-placeholder="开始时间"
              end-placeholder="结束时间"
              placeholder="选择时间范围"
              @change="onTimePickerChange"
            ></el-time-picker>-->

                        <el-time-picker
                            format="HH:mm"
                            clearable
                            editable
                            v-model="workTimeInterval.onDutyTime"
                            placeholder="上班时间点"
                            @change="onDutyTimePickerChange"
                            style="margin-bottom: 20px"
                        ></el-time-picker>

                        <el-time-picker
                            format="HH:mm"
                            clearable
                            editable
                            v-model="workTimeInterval.offDutyTime"
                            placeholder="下班时间点"
                            @change="offDutyTimePickerChange"
                        ></el-time-picker>
                    </el-form-item>
                    <el-row type="flex" justify="end" :gutter="20" style="padding-bottom: 20px">
                        <el-col :span="4">
                            <el-button type="primary" size="small" @click="dialogVisible = false">取消</el-button>
                        </el-col>
                        <el-col :span="4">
                            <el-button type="primary" size="small" @click="editWorkTimeInterval">提交</el-button>
                        </el-col>
                    </el-row>
                </el-form>
            </el-dialog>
        </el-container>
    </div>
</template>
<script>
import elTableColumn from '@/components/common/chjtablecolumn';
import breadcrumb from '@/components/common/breadcrumb';
import pageLimitMixin from '@/mixins/pageLimitMixin';
export default {
    mixins: [pageLimitMixin],
    name: '',
    components: {
        breadcrumb,
        elTableColumn
    },
    data() {
        let userMsg = this.$util.getLocalStorage('userMsg');
        return {
            dialogVisible: false,
            permission: this.$util.getPermission('WorkTimeSections'),
            searchData: {
                entpId: userMsg.EntpId,
                name: '',
                page: 1,
                limit: 15
            },
            workTimeIntervalsList: [],
            workTimeInterval: {
                id: '',
                entpId: userMsg.EntpId,
                name: '',
                onDutyTime: new Date(2020, 4, 1, 0, 0),
                offDutyTime: new Date(2020, 4, 1, 0, 0),
                onDutyHour: 0,
                onDutyMinute: 0,
                offDutyHour: 0,
                offDutyMinute: 0
            },
            workTimeIntervalIds: '',
            rules: {
                name: [{ required: true, message: '请填写时段名称', trigger: 'blur' }]
            }
        };
    },
    created() {
        this.getWorkTimeIntervalsList();
    },
    mounted() {},
    methods: {
        //查询
        getWorkTimeIntervalsList() {
            this.workTimeIntervalsList = [];
            this.$util
                .axiosGet({
                    url: '/api/AttendanceSystem/GetWorkTimeIntervalsList',
                    data: this.searchData
                })
                .then(res => {
                    if (res.data) {
                        this.workTimeIntervalsList = res.data;
                    }
                })
                .catch(err => {});
        },
        onDutyTimePickerChange(value) {
            this.workTimeInterval.onDutyHour = value.getHours();
            this.workTimeInterval.onDutyMinute = value.getMinutes();
        },
        offDutyTimePickerChange(value) {
            this.workTimeInterval.offDutyHour = value.getHours();
            this.workTimeInterval.offDutyMinute = value.getMinutes();
        },
        //显示编辑dialog
        showEditWorkTimeInterval(scope) {
            this.dialogVisible = true;
            this.resetWorkTimeInterval();
            if (scope && scope.row) {
                this.workTimeInterval.id = scope.row.Id;
                this.workTimeInterval.name = scope.row.Name;
                //on
                let startTime = new Date(2020, 1, 1, scope.row.OnDutyHour, scope.row.OnDutyMinute, 0);
                this.workTimeInterval.onDutyHour = scope.row.OnDutyHour;
                this.workTimeInterval.onDutyMinute = scope.row.OnDutyMinute;

                //off
                let endTime = new Date(2020, 1, 1, scope.row.OffDutyHour, scope.row.OffDutyMinute, 0);
                this.workTimeInterval.offDutyHour = scope.row.OffDutyHour;
                this.workTimeInterval.offDutyMinute = scope.row.OffDutyMinute;

                this.workTimeInterval.onDutyTime = startTime;
                this.workTimeInterval.offDutyTime = endTime;
            }
        },
        resetWorkTimeInterval() {
            this.workTimeInterval = {
                id: '',
                entpId: this.workTimeInterval.entpId,
                name: '',
                onDutyTime: new Date(2020, 4, 1, 0, 0),
                offDutyTime: new Date(2020, 4, 1, 0, 0),
                onDutyHour: 0,
                onDutyMinute: 0,
                offDutyHour: 0,
                offDutyMinute: 0
            };
        },
        //新增/编辑
        editWorkTimeInterval() {
            this.$refs['workTimeInterval'].validate(valid => {
                if (valid) {
                    this.$util
                        .axiosPost({
                            url: '/api/AttendanceSystem/EditWorkTimeInterval',
                            data: this.workTimeInterval
                        })
                        .then(res => {
                            if (res.errcode == 0) {
                                this.dialogVisible = false;
                                this.$util.successMsg('保存成功');
                                this.getWorkTimeIntervalsList();
                            }
                        })
                        .catch(err => {});
                } else {
                    return false;
                }
            });
        },
        //删除
        delWorkTimeInterval(scope) {
            if (scope.row) {
                this.workTimeIntervalIds = scope.row.Id;
            }
            this.$util
                .axiosPost({
                    url: '/api/AttendanceSystem/DelWorkTimeInterval?ids=' + this.workTimeIntervalIds
                })
                .then(res => {
                    if (res.errcode == 0) {
                        this.$util.successMsg('删除成功');
                        this.getWorkTimeIntervalsList();
                    }
                })
                .catch(err => {});
        },
        handleSelectionChange(val) {
            this.workTimeIntervalIds = '';
            val.forEach(element => {
                this.workTimeIntervalIds += element.Id + ',';
            });
            this.workTimeIntervalIds = this.workTimeIntervalIds.slice(0, this.workTimeIntervalIds.length - 1);
        },
        // 分页处理
        handleSizeChange(val) {
            this.searchData.page = 1;
            this.searchData.limit = val;
            this.getWorkTimeIntervalsList();
        },
        handleCurrentChange(val) {
            this.searchData.page = val;
            this.getWorkTimeIntervalsList();
        }
    }
};
</script>
<style lang="less" scoped></style>
